import * as React from 'react';
import {getReactButton, getReactTableLocal} from "../../index";
import {RefObject} from "react";
import {ReactTableState} from "./ReactTable";

interface ReactSearchAsYouTypeData {
    id?: string,
    label?: string,
    labelStyle?: {},
    labelCSS?: (selectedRecordIndex: number) => string,
    textStyle?: {},
    headers?: any[],
    headersCSS?: string,
    rowsCSS?: (row: any, rowIndex: number) => string,
    rowsStyle?: (row: any, rowIndex: number) => {},
    rows?: any[],
    tabIndex? : null,
    divTableContainerCSS?: string,
    highlightSelectedRow?: number, // -1 to turn off
    hightlightSelectedRowCSS?: (row: any, rowIndex: number) => string,
    selectRecordWithRowClick?: boolean,
    toolBarDisplayHeader?: boolean,
    toolBarDisplayFooter?: boolean,
    toolBarNumToDisplay?: number,
    selectColumns?: [],
    saytSelectDisplayColumn?: number,
    onSAYTClickEvent?: (row: any) => {},
    hideSearchOnSelect?: boolean,
    tableStyle?: {},
    showClearButton?: boolean,
    clearButtonTabIndex?: null,
    showSearchButton?: boolean,
    showSearchButtonAfterClearButton?: boolean,
    searchButtonTabIndex?: null,
    disabled?: boolean,
    disableHeaderScrolling?: boolean,
    disableID?: string,
    refreshID?: string,
    toolBarRefreshID?: string,
    onRefresh?: () => {},
    onToolBarRefresh?: () => {},
    noRecordsSelectedText?: string,
    addCustomFilterOptions?: object,
    customFilter?: (row: any) => boolean,
    onFocusOut?: (displayValue?: string) => null,
    isSelectedKey?: string,
    customFilterCSS?: string,
    onSortEvent?: () => void,
    onSAYTTableDisplayEvent?: (tableObj: object) => {},
    divSAYTWindowCSS?: string,
    onBeforeSAYTTableDisplayEvent?: () => null,
    onClearButtonClick?: () => null,
    allowFreeTextInput?: boolean,
    addCustomFreeTextRow?: (displayValue?: string) => {},
    isFreeTextKey?: string,
}

interface ReactSearchAsYouTypeState {
    showTable: boolean,
    searchValue: string,
    highlightSelectedRow: number,
    toolBarPageNumber: number,
    toolBarPageNumberTyped: number,
    rows: any[], // All Rows
    headers: any[],
    filteredRows: any[], // Displayed SAYT Table Rows
    disabled: boolean
}

export class ReactSearchAsYouType extends React.Component<ReactSearchAsYouTypeData> {
    useHighlightSelectedRow: boolean;
    inputRef: RefObject<any>;

    constructor(props: ReactSearchAsYouTypeData) {
        super(props);

        // Binding is necessary to allow these functions access to the State data
        this.handleChange = this.handleChange.bind(this);
        this.filterTable = this.filterTable.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onSelectCellClick = this.onSelectCellClick.bind(this);
        this.toolBarPageLeft = this.toolBarPageLeft.bind(this);
        this.toolBarPageRight = this.toolBarPageRight.bind(this);
        this.onClearBtnClick = this.onClearBtnClick.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
        this.sortUpdate = this.sortUpdate.bind(this);
        this.onRefresh = this.onRefresh.bind(this);

        this.inputRef = React.createRef();
        this.useHighlightSelectedRow = props.highlightSelectedRow >= 0;
        (this.state as ReactSearchAsYouTypeState) = {
            showTable: false,
            searchValue: '',
            highlightSelectedRow: props.highlightSelectedRow,
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1,
            rows: props.rows,
            headers: props.headers,
            filteredRows: this.filterTable('', props.rows),
            disabled: props.disabled
        };
    }

    componentDidMount() {
        if(this.props.selectColumns.length > 0) {
            let searchVal = '';
            this.setState(() => {
                (this.state as ReactSearchAsYouTypeState).rows.map((row: any) => {
                    let rowIsSelected = (null != row[this.props.isSelectedKey]) ? row[this.props.isSelectedKey] : false;

                    if(rowIsSelected) {
                        let displayKey = (null != this.props.headers[this.props.saytSelectDisplayColumn].displayKey) ? this.props.headers[this.props.saytSelectDisplayColumn].displayKey : '';
                        if(displayKey.length > 0) {
                            searchVal = row[displayKey];
                        }
                    }
                });

                return {
                    searchValue: searchVal,
                    rows: (this.state as ReactSearchAsYouTypeState).rows,
                    filteredRows: this.filterTable('', (this.state as ReactSearchAsYouTypeState).rows)
                }
            });
        }
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactSearchAsYouTypeData) {
        let searchVal = '';
        this.setState(() => {

            // Get the currently selected value so we can update the State with the correct display
            props.rows.map((row: any) => {
                let rowIsSelected = (null != row[this.props.isSelectedKey]) ? row[this.props.isSelectedKey] : false;
                if(rowIsSelected) {
                    let displayKey = (null != this.props.headers[this.props.saytSelectDisplayColumn].displayKey) ? this.props.headers[this.props.saytSelectDisplayColumn].displayKey : '';
                    if(displayKey.length > 0) {
                        searchVal = row[displayKey];
                    }
                }
            });

            return {
                disabled: props.disabled,
                rows: props.rows,
                searchValue: searchVal
            }
        });
    }

    // User changed something in the SAYT Text field
    handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        // If we allow Free Text then clear the selection when user types
        if(this.props.allowFreeTextInput) {
            let index = this.indexOfSelected();
            while(index >= 0) {
                (this.state as ReactSearchAsYouTypeState).rows[index][this.props.isSelectedKey] = false;
                index = this.indexOfSelected();
            }
        }

        this.setState({
            searchValue: event.target.value,
            rows: (this.state as ReactSearchAsYouTypeState).rows,
            filteredRows: this.filterTable(event.target.value, (this.state as ReactSearchAsYouTypeState).rows),
            headers: (this.state as ReactSearchAsYouTypeState).headers,
            highlightSelectedRow: ((this.state as ReactSearchAsYouTypeState).highlightSelectedRow == -1) ? -1 : 0,
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1,
        });
    }

    // Filter using the Search String
    searchCell(header: any, row: any, searchValLowerCase: string) {
        let searchKey = (null != header.displayKey) ? header.displayKey : '';
        if(null != header.hiddenSearchKey) {
            searchKey = header.hiddenSearchKey;
        }

        // Some columns can be excluded from the search (by default all columns are searched on)
        if(null != header.disableSearch) {
            return false
        } else if(searchKey.length > 0 && row[searchKey]) {
            if(typeof row[searchKey] == "string") {
                return row[searchKey].toLowerCase().includes(searchValLowerCase);
            } else if(typeof row[searchKey] == "number") {
                return row[searchKey].toString().includes(searchValLowerCase);
            } else if(null != row[searchKey].props) {
                if(null != row[searchKey].props.value) {
                    return row[searchKey].props.value.toLowerCase().includes(searchValLowerCase);
                }
            }
        }
        return false;
    }

    searchRow(row: any[], searchValLowerCase: string) {
        let skipCustomFilter = true;

        // Filter using the customFilter in addition to the SAYT
        if(null != this.props.customFilter) {
            skipCustomFilter = this.props.customFilter(row);
        }

        // Filter using the SAYT
        return skipCustomFilter && ((searchValLowerCase.length > 0) ? this.props.headers.map((header, cellIndex) => this.searchCell(header, row, searchValLowerCase)).includes(true) : true);
    }

    filterTable(searchVal: string, rows: any[]) {
        const searchValLowerCase = (searchVal.length > 0) ? searchVal.toLowerCase() : '';
        return rows.filter(row => this.searchRow(row, searchValLowerCase.trim()));
    }

    onClick() {
        this.inputRef.current.focus();

        if(!(this.state as ReactSearchAsYouTypeState).showTable && null != this.props.onBeforeSAYTTableDisplayEvent) {
            this.props.onBeforeSAYTTableDisplayEvent()
        }

        this.setState({
            showTable: true,
            searchValue: '',
            filteredRows: this.filterTable('', (this.state as ReactSearchAsYouTypeState).rows),
            highlightSelectedRow: ((this.state as ReactSearchAsYouTypeState).highlightSelectedRow == -1) ? -1 : 0,
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1
        });

        // Add a mousedown event to trigger once we click away from the SAYT
        const targetElement = $(this.inputRef.current);
        const clickEvent = 'mousedown.' + this.props.id;
        $(document.body).on(clickEvent, (event2) => {
            if(targetElement.closest('div').find($(event2.target)).length < 1) {
                this.onFocusOut();
            }
        });
    }

    onFocusIn(event: any) {
        const targetElement = $(event.target);
        targetElement[0].select();

        // Add a mousedown event to trigger once we click away from the SAYT
        const clickEvent = 'mousedown.' + this.props.id;
        $(document.body).on(clickEvent, (event2) => {
            if(targetElement.closest('div').find($(event2.target)).length < 1) {
                this.onFocusOut();
            }
        });
    }

    onFocusOut() {
        // Remove mousedown event listener that was added when we displayed the SAYT Search Table
        const clickEvent = 'mousedown.' + this.props.id;
        $(document.body).off(clickEvent);

        // Get the Json Object for the displayKey out of the header (which header to use is determined by the saytSelectDisplayColumn value)
        let displayKey = '';
        if(this.props.saytSelectDisplayColumn >= 0 && this.props.saytSelectDisplayColumn < this.props.headers.length && this.props.headers[this.props.saytSelectDisplayColumn]) {
            displayKey = (null != this.props.headers[this.props.saytSelectDisplayColumn].displayKey) ? this.props.headers[this.props.saytSelectDisplayColumn].displayKey : '';
        }

        // Get the new value to display
        let displayVal = (this.state as ReactSearchAsYouTypeState).searchValue;
        let bSelectionFound = false;
        for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
            // Find the first value marked as selected
            if((this.state as ReactSearchAsYouTypeState).rows[i][this.props.isSelectedKey]) {
                if(displayKey.length > 0 && this.props.saytSelectDisplayColumn >= 0 && this.props.saytSelectDisplayColumn < (this.state as ReactSearchAsYouTypeState).rows.length) {
                    displayVal = (this.state as ReactSearchAsYouTypeState).rows[i][displayKey];
                } else {
                    console.log("ERROR: saytSelectDisplayColumn is OUT OR RANGE");
                }
                bSelectionFound = true;
                break; // Stop searching (there should be only one value selected on a SAYT)
            }
        }

        if(!bSelectionFound && displayVal.length > 0) {
            if (this.props.allowFreeTextInput) {
                // Check if typed in value already exists in the list and if so select it
                const index = this.indexOfFreeText(displayVal);
                if(index > -1) {
                    (this.state as ReactSearchAsYouTypeState).rows[index][this.props.isSelectedKey] = true;
                    if(displayKey.length > 0) {
                        if((this.state as ReactSearchAsYouTypeState).rows[index][this.props.isFreeTextKey]) {
                            (this.state as ReactSearchAsYouTypeState).rows[index][displayKey] = displayVal; // Update the free text previously added (aka fix uppercase characters user forgot to include)
                        } else {
                            displayVal = (this.state as ReactSearchAsYouTypeState).rows[index][displayKey]; // Update to exact text (aka add uppercase characters user didn't bother to type)
                        }
                    }
                } else {
                    // If typed text does not exist add it to the list
                    if(null != this.props.addCustomFreeTextRow) {
                        const rowToAdd = this.props.addCustomFreeTextRow(displayVal);
                        if(null !== rowToAdd) {
                            (this.state as ReactSearchAsYouTypeState).rows.push(rowToAdd);
                        }
                    } else {
                        const jsonData: any = {};
                        jsonData[this.props.isSelectedKey] = true;
                        jsonData[this.props.isFreeTextKey] = true;
                        jsonData[displayKey] = displayVal;
                        (this.state as ReactSearchAsYouTypeState).rows.push(jsonData);
                    }
                }
            } else {
                displayVal = '';
            }
        }

        // Update the state
        this.setState({
            rows: (this.state as ReactSearchAsYouTypeState).rows,
            showTable: false,
            searchValue: displayVal
        });

        // Call focus out function if one exists
        if(this.props.onFocusOut) {
            this.props.onFocusOut(displayVal);
        }
    }

    // Get the next row to highlight for the highlightSelectedRow
    getNextRow(rowIndex: number, keyUp: boolean, totalRows: number) {
        let nextRow = rowIndex;
        if(keyUp) {
            if(nextRow > 0) {
                nextRow--;
            }
        } else {
            if(nextRow < (totalRows - 1)) {
                nextRow++;
            }
        }
        return nextRow;
    }

    // Shift the page left or back to 1
    toolBarPageLeft() {
        this.setState((prev: ReactSearchAsYouTypeState) => ({
            toolBarPageNumber: ((prev.toolBarPageNumber > 1) ? prev.toolBarPageNumber - 1 : 1),
            toolBarPageNumberTyped: ((prev.toolBarPageNumber > 1) ? prev.toolBarPageNumber - 1 : 1),
            highlightSelectedRow: ((this.useHighlightSelectedRow) ? ((prev.toolBarPageNumber > 1) ? 0 : (this.state as ReactSearchAsYouTypeState).highlightSelectedRow): -1)
        }));
    }

    // Shift the page right or to the end
    toolBarPageRight() {
        const totalPages = Math.ceil((this.state as ReactSearchAsYouTypeState).filteredRows.length/this.props.toolBarNumToDisplay);
        this.setState(() => ({
            toolBarPageNumber: (((this.state as ReactSearchAsYouTypeState).toolBarPageNumber < totalPages) ? (this.state as ReactSearchAsYouTypeState).toolBarPageNumber + 1 : (this.state as ReactSearchAsYouTypeState).toolBarPageNumber),
            toolBarPageNumberTyped: (((this.state as ReactSearchAsYouTypeState).toolBarPageNumber < totalPages) ? (this.state as ReactSearchAsYouTypeState).toolBarPageNumber + 1 : (this.state as ReactSearchAsYouTypeState).toolBarPageNumber),
            highlightSelectedRow: ((this.useHighlightSelectedRow) ? (((this.state as ReactSearchAsYouTypeState).toolBarPageNumber < totalPages) ? 0 : (this.state as ReactSearchAsYouTypeState).highlightSelectedRow): -1)
        }));
    }

    // User typed something in the SAYT Text field
    onKeyPress(event: any) {
        const keyUp = event.key == "ArrowUp";
        const keyDown = event.key == "ArrowDown";
        const keyLeft = event.key == "ArrowLeft";
        const keyRight = event.key == "ArrowRight";
        const keyTab = event.key == "Tab";
        const keyEsc = event.key == "Escape";
        const keyEnter = event.key == "Enter";
        const keyDelete = event.key == "Delete";
        const keyBackspace = event.key == "Backspace";
        let keyPressed = false;

        // If the table is not displayed, determine if the key pressed should display it
        // Special keys like "Shift" should not display the table
        if((event.key.length == 1 || (keyUp || keyDown || keyLeft || keyRight || keyEnter || keyDelete || keyBackspace)) && !(this.state as ReactSearchAsYouTypeState).showTable) {
            if(!(this.state as ReactSearchAsYouTypeState).showTable && null != this.props.onBeforeSAYTTableDisplayEvent) {
                this.props.onBeforeSAYTTableDisplayEvent()
            }

            this.setState({
                showTable: true,
                searchValue: '',
                filteredRows: this.filterTable('', (this.state as ReactSearchAsYouTypeState).rows),
                highlightSelectedRow: ((this.state as ReactSearchAsYouTypeState).highlightSelectedRow == -1) ? -1 : 0,
                toolBarPageNumber: 1,
                toolBarPageNumberTyped: 1
            });
        } else if (this.useHighlightSelectedRow && (keyUp || keyDown)) {
            // Adjust the highlight row selected
            let updateHighlightPosition = true;
            let newSelectedRow = this.getNextRow((this.state as ReactSearchAsYouTypeState).highlightSelectedRow, keyUp, (this.state as ReactSearchAsYouTypeState).filteredRows.length);

            // Adjust the page number if needed
            let pageNumber = (this.state as ReactSearchAsYouTypeState).toolBarPageNumber;
            if(keyUp && pageNumber > 1 && (this.state as ReactSearchAsYouTypeState).highlightSelectedRow == 0) {
                newSelectedRow = this.props.toolBarNumToDisplay - 1;
                pageNumber--;
            } else if(keyDown) {
                if((newSelectedRow + ((pageNumber - 1) * this.props.toolBarNumToDisplay)) <= ((this.state as ReactSearchAsYouTypeState).filteredRows.length - 1)) {
                    if(newSelectedRow >= this.props.toolBarNumToDisplay) {
                        const totalPages = Math.ceil((this.state as ReactSearchAsYouTypeState).filteredRows.length/this.props.toolBarNumToDisplay);
                        if (pageNumber < totalPages) {
                            newSelectedRow = 0;
                            pageNumber++;
                        } else {
                            updateHighlightPosition = false;
                        }
                    }
                } else {
                    updateHighlightPosition = false;
                }
            }

            keyPressed = true;

            // If the highlight position should be adjusted update the state
            if(updateHighlightPosition) {
                this.setState({
                    highlightSelectedRow: newSelectedRow,
                    toolBarPageNumber: pageNumber,
                    toolBarPageNumberTyped: pageNumber
                });
            }
        } else if (keyLeft || keyRight) {
            // Update the page number using the left and right keyboard arrow keys
            if (keyLeft) {
                this.toolBarPageLeft();
                keyPressed = true;
            } else if (keyRight) {
                this.toolBarPageRight();
                keyPressed = true;
            }
        } else if(keyTab || keyEsc) {
            this.onFocusOut();
        } else if(keyEnter) {
            // Select the highlight selected row on enter
            if(this.useHighlightSelectedRow) {
                const selectIndex = (this.state as ReactSearchAsYouTypeState).highlightSelectedRow + (((this.state as ReactSearchAsYouTypeState).toolBarPageNumber - 1) * this.props.toolBarNumToDisplay);
                if(selectIndex >= 0 && selectIndex < (this.state as ReactSearchAsYouTypeState).rows.length) {
                    this.onSelectCellClick((this.state as ReactSearchAsYouTypeState).filteredRows[selectIndex]);
                }
            }
        }

        if (keyPressed) {
            event.preventDefault();
        }
    }

    // Get the index for the row in the rows array
    indexOfRow(row: any) {
        for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
            if(row == (this.state as ReactSearchAsYouTypeState).rows[i] as any) {
                return i;
            }
        }

        return -1;
    }

    // Select the row
    onSelectCellClick(row: any) {
        const rowIndex = this.indexOfRow(row);
        if(!(this.state as ReactSearchAsYouTypeState).disabled && rowIndex >= 0) {
            // Mark the row passed in as selected and mark all other rows as unselected
            for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
                (this.state as ReactSearchAsYouTypeState).rows[i][this.props.isSelectedKey] = (i == rowIndex);
            }

            // Check if we should close the table on select
            if(this.props.hideSearchOnSelect) {
                this.setState({
                    highlightSelectedRow: (((this.state as ReactSearchAsYouTypeState).highlightSelectedRow > -1) ? 0 : -1),
                    toolBarPageNumber: 1,
                    toolBarPageNumberTyped: 1
                });

                this.onFocusOut();
            }

            // Call the onSAYTClickEvent function if it exists
            if(null != this.props.onSAYTClickEvent) {
                this.props.onSAYTClickEvent(row);
            }
        }
    }

    // Build the SAYT label
    buildLabel() {
        return <label style={this.props.labelStyle} className={(null != this.props.labelCSS) ? this.props.labelCSS(this.indexOfSelected()) : ""}>
            {this.props.label}
        </label>
    }

    // Get the index of the first selected row (should only be one row selected)
    indexOfSelected() {
        for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
            if((this.state as ReactSearchAsYouTypeState).rows[i][this.props.isSelectedKey]) {
                return i;
            }
        }

        return -1;
    }

    // Get the index of the first row matching the text value
    indexOfFreeText(freeText: string) {
        const displayKey = (null != this.props.headers[this.props.saytSelectDisplayColumn].displayKey) ? this.props.headers[this.props.saytSelectDisplayColumn].displayKey : '';
        if(displayKey.length > 0) {
            for(let i = 0; i < (this.state as ReactSearchAsYouTypeState).rows.length; i++) {
                if((this.state as ReactSearchAsYouTypeState).rows[i][displayKey].toLowerCase() === freeText.toLowerCase()) {
                    return i;
                }
            }
        }

        return -1;
    }

    // Clear all selected SAYT rows
    onClearBtnClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        let index = this.indexOfSelected();
        while(index >= 0) {
            (this.state as ReactSearchAsYouTypeState).rows[index][this.props.isSelectedKey] = false;
            index = this.indexOfSelected();
        }

        // Update the state and when finished updating call the onFocusOut event
        this.setState({
            rows: (this.state as ReactSearchAsYouTypeState).rows,
            searchValue: ""
        }, () => {
            this.onFocusOut();

            if(null != this.props.onClearButtonClick) {
                this.props.onClearButtonClick();
            }
        });
    }

    onDisableClick(event: any) {
        this.setState({
            disabled: !(this.state as ReactSearchAsYouTypeState).disabled
        });
    }

    sortUpdate(props: ReactTableState) {
        this.setState(() => ({
            filteredRows: this.filterTable((this.state as ReactSearchAsYouTypeState).searchValue, props.rows),
        }));
    }

    onRefresh() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }

        this.setState((prev: ReactSearchAsYouTypeState) => ({
            filteredRows: this.filterTable(prev.searchValue, (this.state as ReactSearchAsYouTypeState).rows),
            toolBarPageNumber: 1,
            toolBarPageNumberTyped: 1,
        }));
    }

    buildClearButton() {
        return <button id={this.props.id + "_clear"} type="button" className={"searchAsYouTypeButton ui-button ui-corner-all ui-widget ui-button-icon-only" + (((this.state as ReactSearchAsYouTypeState).disabled) ? " ui-button-disabled ui-state-disabled" : "")} tabIndex={this.props.clearButtonTabIndex} title="Clear" onClick={this.onClearBtnClick} disabled={(this.state as ReactSearchAsYouTypeState).disabled} >
            <div>
                <span className="ui-button-icon ui-icon ui-icon-circle-close"></span>
                <span className="ui-button-icon-space"></span>
                Clear
            </div>
        </button>;
    }

    buildSearchButton() {
        return <button id={this.props.id + "_search"} className={"searchAsYouTypeButton ui-button ui-corner-all ui-widget ui-button-icon-only" + (((this.state as ReactSearchAsYouTypeState).disabled) ? " ui-button-disabled ui-state-disabled" : "")} tabIndex={this.props.searchButtonTabIndex} type="button" title="Search" onClick={this.onClick} disabled={(this.state as ReactSearchAsYouTypeState).disabled}>
            <span className="ui-button-icon ui-icon ui-icon-search"></span><span className="ui-button-icon-space"></span>
            Search
        </button>;
    }

    buildSAYTButtons() {
        const clearButton = (this.props.showClearButton) ? this.buildClearButton() : null;
        const searchButton = (this.props.showSearchButton) ? this.buildSearchButton() : null;

        return <td className='nowrap' style={{verticalAlign: "middle", paddingLeft: "4px"}}>
            {(this.props.showSearchButtonAfterClearButton) ? clearButton : searchButton}
            <span style={{paddingLeft: (null != clearButton && null != searchButton) ? '4px' : '0px'}}></span>
            {(this.props.showSearchButtonAfterClearButton) ? searchButton : clearButton}
        </td>
    }

    render() {
        return <div >
            <tr>
                {<table className="categoryAllHide"><tr>
                    <td><input
                        id={this.props.disableID}
                        type="checkbox"
                        onChange={this.onDisableClick}
                        checked={(this.state as ReactSearchAsYouTypeState).disabled}
                    /></td>
                    <td>
                        HIDDEN DISABLE BUTTON
                    </td>
                </tr></table>
                }
                {getReactButton({id: this.props.refreshID, css: "categoryAllHide", onClick: this.onRefresh, text: "HIDDEN REFRESH BUTTON"})}
                <td style={{verticalAlign: "middle"}}>
                    {(this.props.label.length > 0) ? this.buildLabel() : null}
                </td>
                <td style={{verticalAlign: "middle"}}>
                    <table >
                        <tr>
                            <td>
                                <input ref={this.inputRef} id={this.props.id} type="text" value={(this.state as ReactSearchAsYouTypeState).searchValue} style={this.props.textStyle} tabIndex={this.props.tabIndex} onClick={this.onClick} onChange={this.handleChange} onKeyDown={this.onKeyPress} onFocus={this.onFocusIn} disabled={(this.state as ReactSearchAsYouTypeState).disabled}/>
                            </td>
                        </tr>
                        <tr id={this.props.id + '_table_saytTableShell'}>
                            {((this.state as ReactSearchAsYouTypeState).showTable) ? getReactTableLocal({
                                id: this.props.id + '_table',
                                highlightSelectedRow: (this.state as ReactSearchAsYouTypeState).highlightSelectedRow,
                                toolBarPageNumber: (this.state as ReactSearchAsYouTypeState).toolBarPageNumber,
                                toolBarPageNumberTyped: (this.state as ReactSearchAsYouTypeState).toolBarPageNumberTyped,
                                selectColumns: this.props.selectColumns,
                                saytSelectDisplayColumn: this.props.saytSelectDisplayColumn,
                                headers: this.props.headers,
                                headersCSS: this.props.headersCSS,
                                rowsCSS: this.props.rowsCSS,
                                rowsStyle: this.props.rowsStyle,
                                rows: (this.state as ReactSearchAsYouTypeState).rows,
                                filteredRows: (this.state as ReactSearchAsYouTypeState).filteredRows,
                                showTable: (this.state as ReactSearchAsYouTypeState).showTable,
                                isSearchAsYouType: true,
                                style: this.props.tableStyle,
                                toolBarNumToDisplay: this.props.toolBarNumToDisplay,
                                toolBarDisplayHeader: this.props.toolBarDisplayHeader,
                                toolBarDisplayFooter: this.props.toolBarDisplayFooter,
                                toolBarDisplayCompact: true,
                                onSelectCellClick: this.onSelectCellClick,
                                sortUpdate: this.sortUpdate,
                                hideSAYTOnSelect: this.props.hideSearchOnSelect,
                                disableHeaderScrolling: this.props.disableHeaderScrolling,
                                noRecordsSelectedText: this.props.noRecordsSelectedText,
                                addCustomFilterOptions: this.props.addCustomFilterOptions,
                                customFilterCSS: this.props.customFilterCSS,
                                divContainerCSS: this.props.divTableContainerCSS,
                                toolBarRefreshID: this.props.toolBarRefreshID,
                                onToolBarRefresh: this.props.onToolBarRefresh,
                                selectRecordWithRowClick: this.props.selectRecordWithRowClick,
                                isSelectedKey: this.props.isSelectedKey,
                                hightlightSelectedRowCSS: this.props.hightlightSelectedRowCSS,
                                onSortEvent: this.props.onSortEvent,
                                onSAYTTableDisplayEvent: this.props.onSAYTTableDisplayEvent,
                                divSAYTWindowCSS: this.props.divSAYTWindowCSS,
                            }) : null}
                        </tr>
                    </table>
                </td>
                {this.buildSAYTButtons()}
            </tr>
        </div>;
    }
}
